import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";
import { useChatSocket } from "../hooks/useChatSocket";

const NotificationsContext = createContext({ unread: 0, refresh: () => {} });

export function NotificationsProvider({ children }) {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) { setUnread(0); return; }
    try {
      const { data } = await api.get("/notifications/unread");
      setUnread(data.unread_messages || 0);
    } catch {
      setUnread(0);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  useChatSocket(useCallback((payload) => {
    if (payload?.type === "message" && payload.data?.recipient_id === user?.user_id) {
      setUnread((n) => n + 1);
    }
  }, [user]));

  return (
    <NotificationsContext.Provider value={{ unread, refresh, setUnread }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationsContext);
